export default "__VITE_ASSET__Dh$IKQAK__"